// import React, { useState, useRef, useEffect } from "react";
// import "../../assets/Banking/SavingPassbook.css";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import { useLocation } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
// import { Download, Printer } from "lucide-react";

// const RDDDPassbook = () => {
//   const [includeCompany, setIncludeCompany] = useState(true);
//   const [orientation, setOrientation] = useState("portrait");
//   const [company, setCompany] = useState(null);
//   const [branch, setBranch] = useState(null);
//   const [customer, setCustomer] = useState(null);
//   const [customerPhotoUrl, setCustomerPhotoUrl] = useState(null);

//   const { profile } = useSelector((state) => state.userProfile);
//   const dispatch = useDispatch();
//   const componentRef = useRef(null);
//   console.log("profilte",profile)

//   const { state } = useLocation();
//   const currentRowData = state?.row;

//   console.log("currentData", currentRowData);

//   /* -----------------------------------------
//      PDF GENERATE FUNCTION
//   ----------------------------------------- */
//   const generatePDF = async () => {
//     const input = componentRef.current;

//     const printSection = document.querySelector(".Savingprint-options");
//     if (printSection) printSection.style.display = "none";

//     const canvas = await html2canvas(input, {
//       scale: 2,
//       useCORS: true,
//       backgroundColor: "#fff",
//     });

//     if (printSection) printSection.style.display = "block";

//     const imgData = canvas.toDataURL("image/png");

//     const pdf = new jsPDF(orientation, "mm", "a4");
//     const pageWidth = pdf.internal.pageSize.getWidth();
//     const pageHeight = pdf.internal.pageSize.getHeight();

//     const imgWidth = pageWidth;
//     const imgHeight = (canvas.height * imgWidth) / canvas.width;

//     let heightLeft = imgHeight;
//     let position = 0;

//     pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
//     heightLeft -= pageHeight;

//     while (heightLeft > 0) {
//       position = heightLeft - imgHeight;
//       pdf.addPage();
//       pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
//       heightLeft -= pageHeight;
//     }

//     pdf.save("SavingPassbook.pdf");
//   };

//   // Direct print
//   const handleDirectPrint = async () => {
//     const input = componentRef.current;

//     const printSection = document.querySelector(".Savingprint-options");
//     if (printSection) printSection.style.display = "none";

//     // Convert HTML to Canvas
//     const canvas = await html2canvas(input, {
//       scale: 2,
//       useCORS: true,
//       backgroundColor: "#fff",
//     });

//     if (printSection) printSection.style.display = "block";

//     // Canvas to image
//     const imgData = canvas.toDataURL("image/png");

//     // Create a new window for printing
//     const printWindow = window.open();
//     printWindow.document.write(`
//         <html>
// <head>
//   <title>Print Passbook</title>
//   <style>
//   @page {
//     size: 105mm 150mm;
//     margin: 0;
//   }

//   body {
//     margin: 0;
//     padding: 0;
//     width: 105mm;
//     height: 150mm;
//     overflow: hidden;
//   }

//   img {
//     display: block;
//     width: 150mm;          /* swapped */
//     height: 105mm;         /* swapped */
//     transform: rotate(90deg) translateY(-80mm);
//     transform-origin: top left;
//     object-fit: contain;
//   }
// </style>

// </head>

//   <body>
//     <img src="${imgData}" />
//   </body>
// </html>

//     `);

//     printWindow.document.close();

//     // Wait a little before printing so image loads
//     printWindow.onload = function () {
//       printWindow.focus();
//       printWindow.print();
//       printWindow.close();
//     };
//   };

//   // fetch dynamic data for profile, company, customer, branch and customer photo
//   useEffect(() => {
//     const loadAll = async () => {
//       try {
//         const profileData =
//           profile || (await dispatch(fetchUserProfile())).payload;
//         if (!profileData) {
//           console.error("❌ Profile not loaded");
//           return;
//         }

//         /* ------------------------- COMPANY ------------------------- */
//         if (profileData.superAdminId) {
//           try {
//             const res = await fetch(
//               `https://narrowitsolution.in/api/get-company?superAdminId=${profileData.superAdminId}`
//             );
//             const data = await res.json();

//             if (res.ok) {
//               if (data.logo) {
//                 data.logoUrl = `https://narrowitsolution.in/${data.logo.replace(
//                   /^images\//,
//                   ""
//                 )}`;
//               }
//               setCompany(data);
//             }
//           } catch (err) {
//             console.error("Company fetch error:", err);
//           }
//         }

//         // console.log(currentRowData.customerId);

//         /* ------------------------- CUSTOMER ------------------------- */
//         if (currentRowData?.customerId) {
//           try {
//             const res = await fetch(
//               `https://narrowitsolution.in/api/customers-get-userId?userId=${currentRowData.customerId}&branchId=${profileData.id}`
//             );

//             const data = await res.json();
//             console.log("Customer API Response:", data);
//             setCustomer(data.data);
//           } catch (err) {
//             console.error("Customer fetch error:", err);
//           }
//         }

//         // fetch customer photo
//         const fetchCustomerPhoto = async () => {
//           if (!currentRowData?.customerId || !profileData?.superAdminId) return;

//           try {
//             const res = await fetch(
//               `https://narrowitsolution.in/api/list-kyc?userId=${currentRowData.customerId}&superAdminId=${profileData.superAdminId}&createdById=${currentRowData.createdById}`
//             );

//             const data = await res.json();
//             console.log("Customer KYC:", data.documents);

//             if (res.ok && data.documents?.length > 0) {
//               const photoDoc = data.documents.find(
//                 (doc) => doc.docName?.toLowerCase() === "photo"
//               );

//               if (photoDoc?.docImage) {
//                 const finalImage = `https://narrowitsolution.in/uploads/${photoDoc.docImage}`;
//                 console.log("Customer Photo URL:", finalImage);
//                 setCustomerPhotoUrl(finalImage);
//               } else {
//                 console.log("No photo found in KYC");
//                 setCustomerPhotoUrl(null);
//               }
//             }
//           } catch (err) {
//             console.error("Failed to fetch customer photo:", err);
//           }
//         };

//         fetchCustomerPhoto();

//         /* ------------------------- BRANCH ------------------------- */
//         if (profileData.branchId) {
//           try {
//             const res = await fetch(
//               `https://narrowitsolution.in/api/get-byId/${profileData.branchId}`
//             );
//             const branchData = await res.json();

//             if (res.ok) {
//               setBranch(branchData.data || branchData);
//             }
//           } catch (err) {
//             console.error("Branch fetch error:", err);
//           }
//         }
//       } catch (err) {
//         console.error("Unexpected Error:", err);
//       }
//     };

//     loadAll();
//   }, []);

//   return (
//     <div className="Savingpassbook-page">
//       <div id="page1" ref={componentRef}>
//         <div
//           className={`SavingPassbook ${
//             orientation === "landscape" ? "horizontal" : "vertical"
//           }`}
//         >
//           {/* Header */}
//           {includeCompany && company && (
//             <div className="Savingcompany-header">
//               <div className="Savingcompany-info">
//                 <div className="Savingcompany-logo">
//                 {company.logoUrl && (
//                   <img
//                     src={company.logoUrl}
//                     alt="Logo"
//                     className=""
//                   />
//                 )}
//                 </div>
//                 {/* <div className="Saving-Company">
//                   <h2>{company.name}</h2>
//                 </div> */}
//                 <div className="Saving-heading-paragraphs">
//                   <h2>{company.name}</h2>

//                   <p>
//                     <span className="Saving-heading-paragraph2">CIN:</span>{" "}
//                     {company.cin}
//                   </p>
//                   <p>
//                     <span className="Saving-heading-paragraph1">Email:</span>{" "}
//                     {company.email}
//                   </p>
//                   <p>
//                     <span className="Saving-heading-paragraph">Phone:</span>{" "}
//                     {company.contact}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Customer & Account Details */}
//           <div className="Savingdetails-card">
//             <div className="Savingcustomer-section">
//               <img
//                 src={
//                   customerPhotoUrl ||
//                   "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg"
//                 }
//                 alt="Customer"
//                 className="Savingcustomer-photo"
//               />

//               <div className="Savingcustomer-info">
//                 <h4>Customer Details</h4>
//                 <p>
//                   <span className="paragraph-text">Name :</span>{" "}
//                   {currentRowData?.customerName  || "N/A"}
//                 </p>
//                 <p>
//                   <span className="paragraph-text">Guardian :</span>{" "}
//                   {customer?.guardianName || "N/A"}
//                 </p>
//                 <p>
//                   <span className="paragraph-text">Aadhar :</span>{" "}
//                   {customer?.aadhaarNumber || "N/A"}
//                 </p>
//                 <p>
//                   <span className="paragraph-text">PAN :</span>{" "}
//                   {customer?.panNumber || "N/A"}
//                 </p>
//               </div>

//               <div className="Savingcustomer-info">
//                 <br />
//                 <p>
//                   <span className="paragraph-text">Cus ID :</span>{" "}
//                   {currentRowData?.customerId}
//                 </p>
//                 <p>
//                   <span className="paragraph-text">Phone :</span>{" "}
//                   {customer?.mobileNumber || "N/A"}
//                 </p>
//                 <p>
//                   <span className="paragraph-text">Address :</span>{" "}
//                   {customer?.address || "N/A"}
//                 </p>
//               </div>

//               <div className="Savingbranch-info">
//                 <h4>Branch Details</h4>
//                 <p>
//                   <span className="paragraph-text">Name :</span>{" "}
//                   {branch?.name || "N/A"}
//                 </p>
//                 <p>
//                   <span className="paragraph-text">Code :</span>{" "}
//                   {branch?.code || "N/A"}
//                 </p>
//                 <p>
//                   <span className="paragraph-text">Address :</span>{" "}
//                   {branch?.address || "N/A"}
//                 </p>
//               </div>
//             </div>

//             {/* Account Details */}
//             <h4 className="Savingaccount-h4">Account Details</h4>
//             <div
//               style={{
//                 flexDirection: orientation === "portrait" ? "column" : "row",
//               }}
//               className="Savingaccount-details-section"
//             >
//               <div className="Savingaccount-details-info">
//                 <p>
//                   <span className="paragraph-text">Account No :</span>{" "}
//                   {currentRowData?.accountNo || "N/A"}
//                 </p>
//                 <p>
//                   <span className="paragraph-text">Account Type :</span>{" "}
//                   {currentRowData?.accountType + " Account" || "N/A"}
//                 </p>
//                 <p>
//                   <span className="paragraph-text">Account Scheme :</span>{" "}
//                   {currentRowData?.schemeName || "N/A"}
//                 </p>
//               </div>

//               <div className="Savingaccount-details-info">
//                 <p>
//                   <span className="paragraph-text">Total Interest :</span>{" "}
//                   {currentRowData?.totalInterest || "N/A"}
//                 </p>
//                 <p>
//                   <span className="paragraph-text">Maturity Amount :</span>{" "}
//                   {currentRowData?.maturityAmount || "N/A"}
//                 </p>
//                 <p>
//                   <span className="paragraph-text">Maturity Date : </span>
//                   {currentRowData?.maturityDate
//                     ? new Date(currentRowData.maturityDate).toLocaleDateString(
//                         "en-IN"
//                       )
//                     : "N/A"}
//                 </p>
//               </div>

//               <div className="Savingaccount-details-branch-info">
//                 <p>
//                   <span className="paragraph-text">Opening Date :</span>{" "}
//                   {currentRowData?.openingDate
//                     ? new Date(currentRowData.openingDate).toLocaleDateString(
//                         "en-GB"
//                       )
//                     : "N/A"}
//                 </p>
//                 <p>
//                   <span className="paragraph-text">Branch :</span>{" "}
//                   {branch?.name}
//                 </p>
//                 <p>
//                   <span className="paragraph-text">Branch Code :</span>{" "}
//                   {branch?.code}
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Print Options */}
//       <div className="Savingprint-options">
//         <h3>🖨️ Print Options</h3>

//         <div className="Savingoption-row">
//           <p>Include Company Details :</p>
//           <label>
//             <input
//               type="radio"
//               name="company"
//               checked={includeCompany}
//               onChange={() => setIncludeCompany(true)}
//             />
//             Yes
//           </label>
//           <label>
//             <input
//               type="radio"
//               name="company"
//               checked={!includeCompany}
//               onChange={() => setIncludeCompany(false)}
//             />
//             No
//           </label>
//         </div>

//         {/* Orientation Selector */}
//         <div className="Savingoption-row">
//           <p>Page Orientation :</p>
//           <label>
//             <input
//               type="radio"
//               name="orientation"
//               checked={orientation === "portrait"}
//               onChange={() => setOrientation("portrait")}
//             />
//             Vertical
//           </label>
//           <label>
//             <input
//               type="radio"
//               name="orientation"
//               checked={orientation === "landscape"}
//               onChange={() => setOrientation("landscape")}
//             />
//             Horizontal
//           </label>
//         </div>

//          <div className="Saving-lines">
//           <label>Top Space (lines) :</label>
//           <select>
//             <option>1 Line</option>
//             <option>2 Line</option>
//             <option>3 Line</option>
//           </select>
//         </div>

//         <button className="Savingpassbookprint-btn" onClick={generatePDF}>
//          <Download size={15}/> Downloand Pdf
//         </button>
//          {
//                   orientation==="landscape" && (
//                 <button
//                   style={{ marginLeft: "20px" }}
//                   className="Savingpassbookprint-btn"
//                   onClick={handleDirectPrint}
//                 >
//                   <Printer size={15} /> Print
//                 </button>
//                   )
//                 }
//       </div>
//     </div>
//   );
// };

// export default RDDDPassbook;

import React, { useState, useRef, useEffect } from "react";
import "../../assets/Banking/SavingPassbook.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import { Download, Printer } from "lucide-react";

const RDDDPassbook = () => {
  const [includeCompany, setIncludeCompany] = useState(true);
  const [orientation, setOrientation] = useState("portrait");
  const [company, setCompany] = useState(null);
  const [branch, setBranch] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [customerPhotoUrl, setCustomerPhotoUrl] = useState(null);

  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();
  const componentRef = useRef(null);

  const { state } = useLocation();
  const currentRowData = state?.row;

  /* ------------------------- PDF Generate ------------------------- */
  const generatePDF = async () => {
    const input = componentRef.current;
    const printSection = document.querySelector(
      ".account-passbook-print-options"
    );

    if (printSection) printSection.style.display = "none";

    const canvas = await html2canvas(input, {
      scale: 3,
      useCORS: true,
      backgroundColor: "#ffffff",
    });

    if (printSection) printSection.style.display = "block";

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = pdf.internal.pageSize.getWidth(); // 210
    const pageHeight = pdf.internal.pageSize.getHeight(); // 297

    // canvas px → mm
    const pxToMm = (px) => px * 0.264583;
    const imgWidth = pxToMm(canvas.width);
    const imgHeight = pxToMm(canvas.height);

    // scale ratio (important)
    const scale = Math.min(pageWidth / imgWidth, pageHeight / imgHeight);

    const finalWidth = imgWidth * scale;
    const finalHeight = imgHeight * scale;

    // center align
    const x = (pageWidth - finalWidth) / 2; // horizontal center
    const y = 0; // top margin (mm) — 0 bhi rakh sakte ho

    pdf.addImage(
      imgData,
      "PNG",
      x,
      y,
      finalWidth,
      finalHeight,
      undefined,
      "FAST"
    );

    pdf.save(`Passbook_${currentRowData?.customerName || "Customer"}.pdf`);
  };

  /* ------------------------- Direct Print ------------------------- */
  const handleDirectPrint = async () => {
    const input = componentRef.current;
    const printSection = document.querySelector(
      ".account-passbook-print-options"
    );
    if (printSection) printSection.style.display = "none";

    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#fff",
    });

    if (printSection) printSection.style.display = "block";

    const imgData = canvas.toDataURL("image/png");
    const isLandscape = orientation === "landscape";

    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
    <html>
      <head>
        <title>Print Passbook</title>
        <style>
             @page { 
        size: ${isLandscape ? "150mm 105mm" : "105mm 150mm"}; 
        margin: 0;
      }
      body {
        margin: 0;
        padding: 0;
      }
      .passbook-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
      }
        </style>
      </head>
      <body>
        <img class="passbook-img" src="${imgData}" />
      </body>
    </html>
  `);

    printWindow.document.close();
    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    };
  };

  /* ------------------------- Fetch Profile & Customer ------------------------- */
  useEffect(() => {
    const loadAll = async () => {
      try {
        const profileData =
          profile || (await dispatch(fetchUserProfile())).payload;
        if (!profileData) return;

        if (profileData.superAdminId) {
          const res = await fetch(
            `https://narrowitsolution.in/api/get-company?superAdminId=${profileData.superAdminId}`
          );
          const data = await res.json();
          if (res.ok) {
            if (data.logo)
              data.logoUrl = `https://narrowitsolution.in/${data.logo.replace(
                /^images\//,
                ""
              )}`;
            setCompany(data);
          }
        }

        if (currentRowData?.customerId) {
          const res = await fetch(
            `https://narrowitsolution.in/api/customers-get-userId?userId=${currentRowData.customerId}&branchId=${profileData.id}`
          );
          const data = await res.json();
          setCustomer(data.data);
        }

        if (currentRowData?.customerId && profileData?.superAdminId) {
          const res = await fetch(
            `https://narrowitsolution.in/api/list-kyc?userId=${currentRowData.customerId}&superAdminId=${profileData.superAdminId}&createdById=${currentRowData.createdById}`
          );
          const data = await res.json();
          const photoDoc = data.documents?.find(
            (doc) => doc.docName?.toLowerCase() === "photo"
          );
          if (photoDoc?.docImage)
            setCustomerPhotoUrl(
              `https://narrowitsolution.in/uploads/${photoDoc.docImage}`
            );
        }

        if (profileData.branchId) {
          const res = await fetch(
            `https://narrowitsolution.in/api/get-byId/${profileData.branchId}`
          );
          const branchData = await res.json();
          setBranch(branchData.data || branchData);
        }
      } catch (err) {
        console.error(err);
      }
    };
    loadAll();
  }, []);

  return (
    <div className="account-passbook-page">
      <div ref={componentRef}>
        <div
          className={`account-passbook ${
            orientation === "landscape" ? "horizontal" : "vertical"
          }`}
        >
          {/* Header */}
          {includeCompany && company && (
            <div className="account-passbook-company-header">
              {company.logoUrl && (
                <img
                  src={company.logoUrl}
                  alt="Logo"
                  className="account-passbook-company-logo-img"
                />
              )}
              <div className="account-passbook-heading-paragraphs">
                <h2>{company.name}</h2>
                <p>
                  <span>CIN:</span> {company.cin}
                </p>
                <p>
                  <span>Email:</span> {company.email}
                </p>
                <p>
                  <span>Phone:</span> {company.contact}
                </p>
              </div>
            </div>
          )}

          {/* Customer & Account Details */}
          <div className="account-passbook-details-card">
            <div className="account-passbook-customer-section">
              <h4>Customer Details</h4>
              <div
                className={`account-passbook-customer-details ${
                  orientation === "landscape" ? "horizontal" : "vertical"
                }`}
              >
                <img
                  src={
                    customerPhotoUrl ||
                    "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg"
                  }
                  alt="Customer"
                  className="account-passbook-customer-photo"
                />
                <div
                  className={`account-passbook-customer-info ${
                    orientation === "landscape" ? "horizontal" : "vertical"
                  }`}
                >
                  <div>
                    <p>
                      <span>Name :</span>{" "}
                      {currentRowData?.customerName || "N/A"}
                    </p>
                    <p>
                      <span>Guardian :</span> {customer?.guardianName || "N/A"}
                    </p>
                    <p>
                      <span>Aadhar :</span> {customer?.aadhaarNumber || "N/A"}
                    </p>
                    <p>
                      <span>PAN :</span> {customer?.panNumber || "N/A"}
                    </p>
                  </div>
                  <div>
                    <p>
                      <span>Cus ID :</span> {currentRowData?.customerId}
                    </p>
                    <p>
                      <span>Phone :</span> {customer?.mobileNumber || "N/A"}
                    </p>
                    <p>
                      <span>Address :</span> {customer?.address || "N/A"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <h4 className="account-passbook-branch-h4">Branch Details</h4>
            <div className="account-passbook-branch-info">
              <p>
                <span>Name :</span> {branch?.name || "N/A"}
              </p>
              <p>
                <span>Code :</span> {branch?.code || "N/A"}
              </p>
              <p>
                <span>Address :</span> {branch?.address || "N/A"}
              </p>
            </div>

            {/* Account Details */}
            <h4 className="account-passbook-accouont-h4">Account Details</h4>
            <div
              className={`account-passbook-accouont-details-section-flex ${orientation}`}
            >
              <div className="account-passbook-accouont-details-info">
                <p>
                  <span>Account No :</span> {currentRowData?.accountNo || "N/A"}
                </p>
                <p>
                  <span>Account Type :</span>{" "}
                  {currentRowData?.accountType + " Account" || "N/A"}
                </p>
                <p>
                  <span>Account Scheme :</span>{" "}
                  {currentRowData?.schemeName || "N/A"}
                </p>
              </div>
              <div className="account-passbook-accouont-details-info">
                <p>
                  <span>Total Interest :</span>{" "}
                  {currentRowData?.totalInterest || "N/A"}
                </p>
                <p>
                  <span>Maturity Amount :</span>{" "}
                  {currentRowData?.maturityAmount || "N/A"}
                </p>
                <p>
                  <span>Maturity Date :</span>{" "}
                  {currentRowData?.maturityDate
                    ? new Date(currentRowData.maturityDate).toLocaleDateString(
                        "en-IN"
                      )
                    : "N/A"}
                </p>
              </div>
              <div className="account-passbook-accouont-details-branch-info">
                <p>
                  <span>Opening Date :</span>{" "}
                  {currentRowData?.openingDate
                    ? new Date(currentRowData.openingDate).toLocaleDateString(
                        "en-GB"
                      )
                    : "N/A"}
                </p>
                <p>
                  <span>Branch :</span> {branch?.name}
                </p>
                <p>
                  <span>Branch Code :</span> {branch?.code}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Print Options */}
      <div className="account-passbook-print-options">
        <h3>🖨️ Print & PDF Options</h3>

        <div className="account-passbook-print-option-row">
          <p>Include Company Details :</p>
          <label>
            <input
              type="radio"
              name="company"
              checked={includeCompany}
              onChange={() => setIncludeCompany(true)}
            />{" "}
            Yes
          </label>
          <label>
            <input
              type="radio"
              name="company"
              checked={!includeCompany}
              onChange={() => setIncludeCompany(false)}
            />{" "}
            No
          </label>
        </div>

        <div className="account-passbook-print-option-row">
          <p>Page Orientation :</p>
          <label>
            <input
              type="radio"
              name="orientation"
              checked={orientation === "portrait"}
              onChange={() => setOrientation("portrait")}
            />{" "}
            Vertical
          </label>
          <label>
            <input
              type="radio"
              name="orientation"
              checked={orientation === "landscape"}
              onChange={() => setOrientation("landscape")}
            />{" "}
            Horizontal
          </label>
        </div>

        <button className="account-passbook-print-btn" onClick={generatePDF}>
          <Download size={15} /> Download PDF
        </button>
        <button
          style={{ marginLeft: "10px" }}
          className="account-passbook-print-btn"
          onClick={handleDirectPrint}
        >
          <Printer size={15} /> Print Passbook
        </button>
      </div>
    </div>
  );
};

export default RDDDPassbook;
